module.exports = __webpack_public_path__ + "static/img/banner1.a17a9a87.jpg";